/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Trend_TitleInputs */

const en_fw_bm_trend_title = /** @type {(inputs: Fw_Bm_Trend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly trend`)
};

const id_fw_bm_trend_title = /** @type {(inputs: Fw_Bm_Trend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tren bulanan`)
};

/**
* | output |
* | --- |
* | "Monthly trend" |
*
* @param {Fw_Bm_Trend_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_trend_title = /** @type {((inputs?: Fw_Bm_Trend_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Trend_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_trend_title(inputs)
	return en_fw_bm_trend_title(inputs)
});